<!-- Sección de Sucursales -->
<div class="bg-white rounded-lg shadow-md p-8">
  @if (sucursal_actual() !== null && sucursal_old() !== null) {
    <form (submit)="guardarSucursal()">
      <h2 class="text-2xl font-bold text-slate-900 mb-6 pb-4 border-b border-slate-200">
        Configuración de Sucursales
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label class="block text-sm font-medium text-slate-700 mb-2">Código</label>
          <input
            type="text"
            class="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
            placeholder="Código de sucursal"
            [value]="sucursal_old()!.codigo || ''"
            disabled
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-slate-700 mb-2">Nombre</label>
          <input
            type="text"
            class="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
            placeholder="Nombre de sucursal"
            [formField]="formulario_sucursal.nombre"
            [class.p-invalid]="
              formulario_sucursal.nombre().invalid() && formulario_sucursal.nombre().touched()
            "
          />
          @if (formulario_sucursal.nombre().invalid() && formulario_sucursal.nombre().touched()) {
            <div class="text-xs text-red-500 mt-1">
              {{ formulario_sucursal.nombre().errors() | formErrorMessage }}
            </div>
          }
        </div>

        <div class="md:col-span-2">
          <label class="block text-sm font-medium text-slate-700 mb-2">Dirección</label>
          <input
            type="text"
            class="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
            placeholder="Dirección de sucursal"
            [formField]="formulario_sucursal.direccion"
            [class.p-invalid]="
              formulario_sucursal.direccion().invalid() && formulario_sucursal.direccion().touched()
            "
          />
          @if (
            formulario_sucursal.direccion().invalid() && formulario_sucursal.direccion().touched()
          ) {
            <div class="text-xs text-red-500 mt-1">
              {{ formulario_sucursal.direccion().errors() | formErrorMessage }}
            </div>
          }
        </div>

        <!-- Teléfono -->
        <div>
          <label class="block text-sm font-medium text-slate-700 mb-2">Teléfono</label>
          <app-input-mask
            mask="+51-999-999-999"
            [(value)]="numero_celular"
            placeholder="+51-999-999-999"
            styleClass="w-full"
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-slate-700 mb-2">Email</label>
          <input
            type="email"
            class="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
            placeholder="Email"
            [formField]="formulario_sucursal.email"
            [class.p-invalid]="
              formulario_sucursal.email().invalid() && formulario_sucursal.email().touched()
            "
          />
          @if (formulario_sucursal.email().invalid() && formulario_sucursal.email().touched()) {
            <div class="text-xs text-red-500 mt-1">
              {{ formulario_sucursal.email().errors() | formErrorMessage }}
            </div>
          }
        </div>
      </div>

      <!-- Series y Correlativas -->
      <div class="bg-slate-50 rounded-lg p-6 mb-6">
        <h4 class="font-semibold text-slate-900 mb-4">Configuración de Documentos</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label class="block text-xs font-semibold text-slate-600 uppercase mb-1"
              >Serie Boleta</label
            >
            <input
              type="text"
              class="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Serie"
              [formField]="formulario_sucursal.serie_boleta"
              [class.p-invalid]="
                formulario_sucursal.serie_boleta().invalid() &&
                formulario_sucursal.serie_boleta().touched()
              "
            />
            @if (
              formulario_sucursal.serie_boleta().invalid() &&
              formulario_sucursal.serie_boleta().touched()
            ) {
              <div class="text-xs text-red-500 mt-1">
                {{ formulario_sucursal.serie_boleta().errors() | formErrorMessage }}
              </div>
            }
          </div>
          <div>
            <label class="block text-xs font-semibold text-slate-600 uppercase mb-1"
              >Correlativo Boleta</label
            >
            <input
              type="number"
              class="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Número"
              [formField]="formulario_sucursal.correlativo_boleta"
              [class.p-invalid]="
                formulario_sucursal.correlativo_boleta().invalid() &&
                formulario_sucursal.correlativo_boleta().touched()
              "
            />
            @if (
              formulario_sucursal.correlativo_boleta().invalid() &&
              formulario_sucursal.correlativo_boleta().touched()
            ) {
              <div class="text-xs text-red-500 mt-1">
                {{ formulario_sucursal.correlativo_boleta().errors() | formErrorMessage }}
              </div>
            }
          </div>
          <div>
            <label class="block text-xs font-semibold text-slate-600 uppercase mb-1"
              >Serie Factura</label
            >
            <input
              type="text"
              class="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Serie"
              [formField]="formulario_sucursal.serie_factura"
              [class.p-invalid]="
                formulario_sucursal.serie_factura().invalid() &&
                formulario_sucursal.serie_factura().touched()
              "
            />
            @if (
              formulario_sucursal.serie_factura().invalid() &&
              formulario_sucursal.serie_factura().touched()
            ) {
              <div class="text-xs text-red-500 mt-1">
                {{ formulario_sucursal.serie_factura().errors() | formErrorMessage }}
              </div>
            }
          </div>
          <div>
            <label class="block text-xs font-semibold text-slate-600 uppercase mb-1"
              >Correlativo Factura</label
            >
            <input
              type="number"
              class="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Número"
              [formField]="formulario_sucursal.correlativo_factura"
              [class.p-invalid]="
                formulario_sucursal.correlativo_factura().invalid() &&
                formulario_sucursal.correlativo_factura().touched()
              "
            />
            @if (
              formulario_sucursal.correlativo_factura().invalid() &&
              formulario_sucursal.correlativo_factura().touched()
            ) {
              <div class="text-xs text-red-500 mt-1">
                {{ formulario_sucursal.correlativo_factura().errors() | formErrorMessage }}
              </div>
            }
          </div>
          <div>
            <label class="block text-xs font-semibold text-slate-600 uppercase mb-1"
              >Serie Nota Crédito</label
            >
            <input
              type="text"
              class="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Serie"
              [formField]="formulario_sucursal.serie_nota_credito"
              [class.p-invalid]="
                formulario_sucursal.serie_nota_credito().invalid() &&
                formulario_sucursal.serie_nota_credito().touched()
              "
            />
          </div>
          <div>
            <label class="block text-xs font-semibold text-slate-600 uppercase mb-1"
              >Correlativo Nota Crédito</label
            >
            <input
              type="number"
              class="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Número"
              [formField]="formulario_sucursal.correlativo_nota_credito"
              [class.p-invalid]="
                formulario_sucursal.correlativo_nota_credito().invalid() &&
                formulario_sucursal.correlativo_nota_credito().touched()
              "
            />
            @if (
              formulario_sucursal.correlativo_nota_credito().invalid() &&
              formulario_sucursal.correlativo_nota_credito().touched()
            ) {
              <div class="text-xs text-red-500 mt-1">
                {{ formulario_sucursal.correlativo_nota_credito().errors() | formErrorMessage }}
              </div>
            }
          </div>
          <div>
            <label class="block text-xs font-semibold text-slate-600 uppercase mb-1"
              >Serie Nota Venta</label
            >
            <input
              type="text"
              class="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Serie"
              [formField]="formulario_sucursal.serie_nota_venta"
              [class.p-invalid]="
                formulario_sucursal.serie_nota_venta().invalid() &&
                formulario_sucursal.serie_nota_venta().touched()
              "
            />
            @if (
              formulario_sucursal.serie_nota_venta().invalid() &&
              formulario_sucursal.serie_nota_venta().touched()
            ) {
              <div class="text-xs text-red-500 mt-1">
                {{ formulario_sucursal.serie_nota_venta().errors() | formErrorMessage }}
              </div>
            }
          </div>
          <div>
            <label class="block text-xs font-semibold text-slate-600 uppercase mb-1"
              >Correlativo Nota Venta</label
            >
            <input
              type="number"
              class="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Número"
              [formField]="formulario_sucursal.correlativo_nota_venta"
              [class.p-invalid]="
                formulario_sucursal.correlativo_nota_venta().invalid() &&
                formulario_sucursal.correlativo_nota_venta().touched()
              "
            />
            @if (
              formulario_sucursal.correlativo_nota_venta().invalid() &&
              formulario_sucursal.correlativo_nota_venta().touched()
            ) {
              <div class="text-xs text-red-500 mt-1">
                {{ formulario_sucursal.correlativo_nota_venta().errors() | formErrorMessage }}
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Estados -->
      <div class="flex gap-4 mb-6">
        <label class="flex items-center cursor-pointer">
          <input
            type="checkbox"
            class="w-4 h-4 text-blue-600 rounded"
            [formField]="formulario_sucursal.activo"
          />
          <span class="ml-2 text-slate-700 font-medium">Sucursal Activa</span>
        </label>
        <label class="flex items-center cursor-pointer">
          <input
            type="checkbox"
            class="w-4 h-4 text-green-600 rounded"
            [formField]="formulario_sucursal.es_principal"
          />
          <span class="ml-2 text-slate-700 font-medium">Es Principal</span>
        </label>
      </div>

      <!-- Mensajes de Footer por Comprobante -->
      <div class="bg-slate-50 rounded-lg p-6 mb-6">
        <h4 class="font-semibold text-slate-900 mb-4">Mensajes de Footer por Comprobante</h4>
        <p class="text-xs text-slate-500 mb-4">
          Personaliza el mensaje al pie de cada tipo de comprobante. Si se deja vacío se usará
          "¡Gracias por su compra!".
        </p>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">
              <i class="bi bi-file-earmark-text text-green-600"></i> Factura
            </label>
            <textarea
              rows="2"
              placeholder="Ej: Representación impresa de la factura electrónica."
              class="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              [formField]="formulario_sucursal.footer_factura"
            ></textarea>
          </div>
          <div>
            <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">
              <i class="bi bi-file-earmark-text text-blue-600"></i> Boleta
            </label>
            <textarea
              rows="2"
              placeholder="Ej: Representación impresa de la boleta de venta electrónica."
              class="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              [formField]="formulario_sucursal.footer_boleta"
            ></textarea>
          </div>
          <div>
            <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">
              <i class="bi bi-file-earmark-text text-amber-600"></i> Nota de Venta
            </label>
            <textarea
              rows="2"
              placeholder="Ej: Este documento no es un comprobante fiscal."
              class="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              [formField]="formulario_sucursal.footer_nota_venta"
            ></textarea>
          </div>
        </div>
      </div>

      <button
        type="submit"
        class="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-lg transition duration-200 shadow-md"
        [disabled]="formulario_sucursal().invalid()"
      >
        Guardar Configuración de Sucursal
      </button>
    </form>
  }
</div>
